function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  x: 0.5,
  y: 0.5,
  stroke: "#A4A2A8",
  opacity: 0.254,
  rx: 24
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A4A2A8",
  fillRule: "nonzero",
  d: "M26.591 25l4.773 4.773a1.125 1.125 0 01-1.59 1.591L25 26.591l-4.773 4.773a1.125 1.125 0 01-1.59-1.59L23.408 25l-4.773-4.773a1.125 1.125 0 011.591-1.59L25 23.408l4.773-4.773a1.125 1.125 0 011.591 1.591L26.591 25z"
}));

var SvgMenuCloser = function SvgMenuCloser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OSIgaGVpZ2h0PSI0OSIgdmlld0JveD0iMCAwIDQ5IDQ5Ij4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiB4PSIuNSIgeT0iLjUiIHN0cm9rZT0iI0E0QTJBOCIgb3BhY2l0eT0iLjI1NCIgcng9IjI0Ii8+CiAgICA8cGF0aCBmaWxsPSIjQTRBMkE4IiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0xMC4xMjUsNy44NzUgTDE2Ljg3NSw3Ljg3NSBDMTcuNDk2MzIwMyw3Ljg3NSAxOCw4LjM3ODY3OTY2IDE4LDkgQzE4LDkuNjIxMzIwMzQgMTcuNDk2MzIwMywxMC4xMjUgMTYuODc1LDEwLjEyNSBMMTAuMTI1LDEwLjEyNSBMMTAuMTI1LDE2Ljg3NSBDMTAuMTI1LDE3LjQ5NjMyMDMgOS42MjEzMjAzNCwxOCA5LDE4IEM4LjM3ODY3OTY2LDE4IDcuODc1LDE3LjQ5NjMyMDMgNy44NzUsMTYuODc1IEw3Ljg3NSwxMC4xMjUgTDEuMTI1LDEwLjEyNSBDMC41MDM2Nzk2NTYsMTAuMTI1IDAsOS42MjEzMjAzNCAwLDkgQzAsOC4zNzg2Nzk2NiAwLjUwMzY3OTY1Niw3Ljg3NSAxLjEyNSw3Ljg3NSBMNy44NzUsNy44NzUgTDcuODc1LDEuMTI1IEM3Ljg3NSwwLjUwMzY3OTY1NiA4LjM3ODY3OTY2LDAgOSwwIEM5LjYyMTMyMDM0LDAgMTAuMTI1LDAuNTAzNjc5NjU2IDEwLjEyNSwxLjEyNSBMMTAuMTI1LDcuODc1IFoiIHRyYW5zZm9ybT0icm90YXRlKDQ1IC0yLjMxNCAzNi4zMTQpIi8+CiAgPC9nPgo8L3N2Zz4K";
export { SvgMenuCloser as ReactComponent };